import { bus } from "@/bus";
import { http } from "@/communication";
import Vue from "vue";
import swal from "sweetalert2";

const uploadProgressModule = {
  namespaced: true,
  state: {
    size: null,
    type: null,
    percentage: null,
    error: null,
    isDialogImage: null,
    uploaded: false,
    successMessage: null
  },
  actions: {
    uploadMedia({ commit }, { url, data, meta, successMessage }) {
      commit("type", meta[0]);
      commit("size", meta[1]);
      commit("error", null);
      commit("successMessage", successMessage);

      new Vue().$modal.hide("audio-upload");
      new Vue().$modal.hide("audio-record");
      new Vue().$modal.show("upload-modal");
      let size = meta[1] !== null ? meta[1] : 0;
      http
        .post(url, data, {
          onUploadProgress: function(uploadEvent) {
            if (size == 0) {
              size = uploadEvent.total;
              commit("size", size);
            }
            let percent = Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            );
            commit("percentage", percent);
          }.bind(this)
        })
        .then(resp => {
          bus.$emit("media-uploaded", resp.data);
        })
        .catch(error => {
          if (error.response.data.errors) {
            commit("error", error.response.data.errors.file[0]);
          } else {
            commit("error", error.response.data);
          }
        })
        .finally(() => {
          commit("finished");
        });
    },
    triggerAlert({ commit, state }) {
      commit("started");
      new Vue().$modal.hide("upload-modal");
      if (!state.error) {
        swal.fire({
          text: state.successMessage,
          type: "success",
          timer: 5000,
          showConfirmButton: false,
          showCancelButton: false
        });
      } else {
        swal.fire({
          text: state.error,
          type: "error",
          showConfirmButton: true,
          confirmButtonText: "Ok, verstanden"
        });
      }
    }
  },
  mutations: {
    percentage(state, percentage) {
      state.percentage = percentage;
    },
    size(state, size) {
      state.size = size;
    },
    type(state, type) {
      state.type = type;
    },
    error(state, error) {
      state.error = error;
    },
    isDialogImage(state, isDialogImage) {
      state.isDialogImage = isDialogImage;
    },
    successMessage(state, successMessage) {
      state.successMessage = successMessage;
    },
    started(state) {
      state.uploaded = false;
    },
    finished(state) {
      state.uploaded = true;
    }
  },
  getters: {
    percentage({ percentage }) {
      return percentage;
    },
    size({ size }) {
      return size;
    },
    type({ type }) {
      return type;
    },
    error({ error }) {
      return error;
    },
    isDialogImage({ isDialogImage }) {
      return isDialogImage;
    },
    uploaded({ uploaded }) {
      return uploaded;
    },
    successMessage({ successMessage }) {
      return successMessage;
    }
  }
};

export default uploadProgressModule;
